const onlineforms = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Online Forms",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Content",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Form Added!",
              addNewSuccessMessage: "Form Added Successfully!",
              addNewErrorTitle: "Form Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Form Deleted!",
              deleteSuccessMessage: "Form Deleted Successfully!",
              deleteErrorTitle: "Form Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Form Activated!",
              activeSuccessMessage: "Form Activated Successfully!",
              activeErrorTitle: "Form Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Form Updated!",
              updateSuccessMessage: "Form Updated Successfully!",
              updateErrorTitle: "Form Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Form",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Page Name",
                    placeholder: "Enter Page Name",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  group: {
                    type: "onlineGroupSelect",
                    label: "Group",
                    placeholder: "Select Group",
                    load_url: "",
                    required: false,
                    info: false,
                    character_count: 0,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  group: "",
                  link_type: "External Link",
                  link_url: "",
                  label: "",
                  icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/quick_links/building.svg",
                },
              },
            },
            children: [
              {
                type: "footerTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Pages",
                  type: "list",
                  variant: "filtered",
                  filter: "onlineLabels",
                  filterOn: "group",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    preview: {
                      type: "OnlineFormsPreview",
                      label: "Preview",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    path: {
                      type: "text",
                      label: "Path",
                      placeholder: "Enter Path",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    template: {
                      type: "select",
                      label: "Template",
                      placeholder: "Select Template",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Template A"],
                    },
                    title: {
                      type: "text",
                      label: "Name",
                      placeholder: "Enter Name",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "mr-2",
                      size: "6",
                      style: "",
                    },
                    label: {
                      type: "text",
                      label: "Label",
                      placeholder: "Enter Label",
                      required: false,
                      info: false,
                      character_count: 40,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    link_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Enter Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Settings Updated!",
              updateSuccessMessage: "Settings Updated Successfully!",
              updateErrorTitle: "Settings Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    description: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { onlineforms };
